import { useState } from "react";

import { useAppStore } from "../stores/AppStore";
import { useCategoriesStore } from "../stores/CategoriesStore";
import type { CategorySortingProps } from "../types/components/CategorySortingProps";

import "../assets/scss/components/_category-sorting.scss";
import { InternationalCategorySelect } from "./InternationalCategorySelect";

export const CategorySorting = ({ availableTags, activeTags, setActiveTags }: CategorySortingProps) => {
	const { sort, availableSorts, SetActiveSort, currentInternationalCategory } = useCategoriesStore(
		({ sort, availableSorts, SetActiveSort, currentInternationalCategory }) => {
			return { sort, availableSorts, SetActiveSort, currentInternationalCategory };
		},
	);

	const [activeTagsObject, setActiveTagsObject] = useState(activeTags);

	const updateTags = (newTags) => {
		setActiveTagsObject(newTags);
		setActiveTags(newTags);
	};

	const UpdateSort = (e) => {
		SetActiveSort(e.target.value);
	};

	return (
		<section className="category-sorting">
			{Object.keys(availableTags).map((tag, index) => {
				return (
					<div className="category-sorting-section" key={index}>
						<strong>{tag}</strong>
						<div className="category-sorting-section-tags">
							{availableTags[tag].map((value, index) => {
								return (
									<div
										className={`category-sorting-tag ${Object.values(activeTagsObject[tag]).includes(value) ? "active" : ""}`}
										key={index}
										onClick={() => {
											let obj = { ...activeTagsObject };

											if (useAppStore.getState().isDebug) {
												console.log(
													"CategorySorting.js - Active tags object",
													activeTagsObject,
												);
											}

											if (Object.values(activeTagsObject[tag]).includes(value)) {
												var index = obj[tag].indexOf(value);
												if (index !== -1) {
													obj[tag].splice(index, 1);
												}
											} else {
												if (useAppStore.getState().isDebug) {
													console.log("CategorySorting.js - Add tag", value);
												}
												obj[tag].push(value);
											}
											updateTags(obj);
										}}
									>
										{value}
									</div>
								);
							})}
						</div>
					</div>
				);
			})}

			{currentInternationalCategory !== "" ? <InternationalCategorySelect /> : ""}

			<div className="field">
				<label htmlFor="category-sort">Sort By</label>

				<select
					name="category-sort"
					id="category-sort"
					className="category-sorting-section"
					onChange={(e) => {
						UpdateSort(e);
					}}
					value={sort}
				>
					{Object.keys(availableSorts).map((order, index) => {
						return (
							<option value={availableSorts[order]} key={index}>
								{availableSorts[order]}
							</option>
						);
					})}
				</select>
			</div>
		</section>
	);
};
